
import { StandardButton } from "../atoms/buttons"
import { StandardComp } from "../atoms/standardComp"
import { HorizontalLayout, VerticalLayout } from "../components/layout"
import { icon } from "../functions/icons"
import { Badge } from "../atoms/badges"

export const PayCard = ({ payData, onClick }) => {
    const selected = `${payData.selected && "white-color"}`
    const buttonStyle = { width: "100%", margin: "unset", justifyContent: "center", marginTop: "2rem", fontSize: '1rem', padding: "1rem", backgroundColor: payData.active && 'grey' }
    return (
        <StandardComp
            onClick={onClick}
            style={{ backgroundColor: payData.selected && "var(--primary-500)", boxShadow: payData.selected && "0 3px 3px 0px rgba(0,0,0,0.2)", height: "max-content", borderWidth: 0 }}
            content={
                <VerticalLayout>
                    <HorizontalLayout style={{justifyContent:"space-between"}} >
                        <Title
                            title={payData.title}
                            selected={selected} />
                        <OrderBadge
                            extraCredit={payData?.extraCredit}
                        />
                    </HorizontalLayout>
                    <Credit
                        credit={payData.value}
                        selected={selected}
                        id={payData.id}
                        />
                    <CheckList
                        list={payData.feature_list}
                        selected={selected} />
                    <StandardButton
                        style={buttonStyle}
                        title={payData.selected ? `Geselecteerd ${payData?.active ? '(Actief)' : ''}` : `Selecteer ${payData?.active ? '(Actief)' : ''}`}
                        
                        selected={selected} />
                </VerticalLayout>
            }
        />
    )
}


const Title = ({ title, selected }) => {
    return (
        <h5 className={`paycard-title ${selected}`}>{title}</h5>
    )
}

const OrderBadge = ({ extraCredit }) => {
    return (
        extraCredit &&
        <Badge
            badge={"info"}
            label={"+" + " " + extraCredit + " " + "BONUS"}
            rounded={true}
        />
    )
}

const Credit = ({ credit, selected, id }) => {
    return (
        <HorizontalLayout style={{"alignItems": "end"}}>
            <h4 className={`paycard-title ${selected}`}>€{credit},-</h4>
            { id === 4 && <p className={`standard-text-color ${selected}`} style={{"marginLeft": "0.5rem", "color": "var(--standard-text-color)"}}>/credit</p> }
        </HorizontalLayout>
    )
}
const CheckList = ({ list, selected }) => {
    return (
        list.map((feature, index) => {
            return (
                <HorizontalLayout style={{ marginTop: "0.75rem" }}>
                    {icon("check", "20px", selected)}
                    <p className={`paycard-description standard-text ${selected}`}>{feature.description} </p>
                </HorizontalLayout>
            )
        })

    )
}

